import { render, staticRenderFns } from "./UpdateFieldDialog.vue?vue&type=template&id=653219f4&scoped=true&"
import script from "./UpdateFieldDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFieldDialog.vue?vue&type=style&index=0&id=653219f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653219f4",
  null
  
)

export default component.exports